import { render, staticRenderFns } from "./UploadImageAlt.vue?vue&type=template&id=18b9101e&scoped=true"
import script from "./UploadImageAlt.vue?vue&type=script&lang=js"
export * from "./UploadImageAlt.vue?vue&type=script&lang=js"
import style0 from "./UploadImageAlt.vue?vue&type=style&index=0&id=18b9101e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9101e",
  null
  
)

export default component.exports